import { render, staticRenderFns } from "./DepotModal.vue?vue&type=template&id=2c6db6e8&scoped=true"
import script from "./DepotModal.vue?vue&type=script&lang=js"
export * from "./DepotModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6db6e8",
  null
  
)

export default component.exports